import { PageHero, SitePage } from "@/components/SitePage";
import SectionLabel from "@/components/SectionLabel";
import HomeClosingCTA from "@/components/HomeClosingCTA";

const phases = [
  ["01", "Define", "We review the operating context, the systems involved and the outcome the programme must deliver.", "Priorities, measures and scope"],
  ["02", "Design", "We set the target workflow, technical architecture, governance requirements and implementation sequence.", "Delivery plan and system design"],
  ["03", "Implement", "Our team builds and integrates the solution with regular reviews from business and technical owners.", "Tested working system"],
  ["04", "Adopt", "We prepare operating teams, transfer knowledge and review results against the agreed measures.", "Operational ownership"],
];

const principles = [
  ["One delivery team", "Advisory, design and engineering work against the same priorities and plan."],
  ["Regular working reviews", "Stakeholders review the system and the operating change throughout delivery."],
  ["Clear controls", "Security, governance and ownership are defined as part of the implementation."],
  ["Planned handover", "Documentation, training and internal ownership are included in the delivery scope."],
];

export default function HowWeWork() {
  return (
    <SitePage>
      <PageHero
        label="Approach"
        title="A delivery model for complex transformation."
        intro="Averentia brings business planning, technology delivery and adoption into one programme. The work is structured around operating priorities and clear measures."
        aside={<><span>Working model</span><strong>Define<br />Design<br />Implement<br />Adopt</strong></>}
      />
      <section className="av-section av-method av-page-section" aria-labelledby="delivery-phases">
        <div className="av-shell av-method-grid">
          <div>
            <SectionLabel>Delivery phases</SectionLabel>
            <h2 id="delivery-phases">From initial scope to operational ownership.</h2>
          </div>
          <ol className="av-phase-list">
            {phases.map(([number, title, text, output]) => (
              <li key={number}>
                <span className="av-index">{number}</span>
                <div><h3>{title}</h3><p>{text}</p><small>{output}</small></div>
              </li>
            ))}
          </ol>
        </div>
      </section>
      <section className="av-section av-page-section" aria-labelledby="working-principles">
        <div className="av-shell av-split">
          <div>
            <SectionLabel>Working principles</SectionLabel>
            <h2 id="working-principles">What clients can expect.</h2>
          </div>
          <div className="av-principle-list">
            {principles.map(([title, text], index) => (
              <article key={title}>
                <span className="av-index">{String(index + 1).padStart(2, "0")}</span>
                <h3>{title}</h3><p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
      <HomeClosingCTA />
    </SitePage>
  );
}
